import { Strings } from '@raydiant/api-client-js';
import LocalizedStrings from 'react-localization';

export default function localizeAppStrings(strings: Strings) {
  return strings && 'en' in strings ? new LocalizedStrings(strings) : {};
}
